module.exports = __webpack_public_path__ + "img/dizaine.f0bdab13.png";